import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import 'bootstrap4-duallistbox'
import 'bootstrap4-duallistbox/dist/bootstrap-duallistbox.css'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import Loading from '../ui/Loading.js'
import 'react-select/dist/react-select.css'
import 'moment/min/locales'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import DatePicker from 'react-datepicker'
import moment from 'moment'
import 'react-dropzone-component/styles/filepicker.css'
import 'react-datepicker/dist/react-datepicker.css'
import 'dropzone/dist/min/dropzone.min.css'
import Validator from '../../commons/validation/Validator.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import swal from 'sweetalert2';

class ConfigPeriodosPresupuestariosAbm extends Component {
	constructor(props) {
		super(props);
		this.ajaxHandler = new AjaxHandler();
		
		this.state = {
			redirectTo: null,
			props: this.props,
			formData: {
				id: 0,
				nombre: '',
                frecuencia: '',
                duracion: '',
                fecha_inicio: null,
			},
			errors: [],
			frecuenciasBase: [
				{ value: 'mensual', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Mensual", defaultMessage:"Mensual"}), meses: 1},
				{ value: 'bimestral', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Bimestral", defaultMessage:"Bimestral"}), meses: 2 },
				{ value: 'trimestral', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Trimestral", defaultMessage:"Trimestral"}), meses: 3 },
				{ value: 'cuatrimestral', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Cuatrimestral", defaultMessage:"Cuatrimestral"}), meses: 4 },
				{ value: 'semestral', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Semestral", defaultMessage:"Semestral"}), meses: 6 },
				{ value: 'anual', label: this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.frecuencias.Anual", defaultMessage:"Anual"}), meses: 12 }
			],
			duraciones: [
				{value: 1, label: 1 + " "+ this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Mes", defaultMessage:"Mes"})},
				{value: 3, label: 3 + " "+ this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Meses", defaultMessage:"Meses"})},
				{value: 6, label: 6 + " "+ this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Meses", defaultMessage:"Meses"})},
				{value: 12, label: 1 + " " + this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Año", defaultMessage:"Año"})},
				{value: 24, label: 2 + " " + this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage:"Años"})},
				{value: 36, label: 3 + " " + this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage:"Años"})},
				{value: 48, label: 4 + " " + this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage:"Años"})},
				{value: 60, label: 5 + " " + this.props.intl.formatMessage({id: "ConfigPeriodosPresupuestariosAbm.duraciones.Años", defaultMessage:"Años"})}
			],
			frecuencias: [],
			loading: false
		};
		
		this.handleInputFormChange = this.handleInputFormChange.bind(this);
		
		this.handleSubmit = this.handleSubmit.bind(this);

		let validators = {
			'formData.nombre': (value) => Validator.notEmpty(value),
			'formData.duracion': (value) => Validator.notEmpty(value),
			'formData.frecuencia': (value) => Validator.notEmpty(value),
			'formData.fecha_inicio': (value) => Validator.notEmpty(value)
		}

		this.formValidation = new FormValidation({
			component: this,			
			validators: validators
		});
  	}


  	componentWillUnmount() {
		this.ajaxHandler.unsubscribe();
	}

	componentWillMount() {
			this.ajaxHandler.subscribe(this);
			this.initForm();
  	}

  	initForm() {
		this.setState({ loading: true });
		let component = this;
		
		Promise.all([
			this.state.props.action !== 'ADD' ? this.ajaxHandler.getJson('/periodo-configs/' + this.state.props.match.params.id) : null,
		]).then((data) => {
			let formData = data[0].periodos;
			if(formData){
				formData[0].frecuencia = component.state.frecuenciasBase.find(f => f.value === formData[0].frecuencia);
				formData[0].duracion = component.state.duraciones.find(d => d.value === formData[0].duracion);
				let frecuencias = [];
				if(formData[0].frecuencia){
					frecuencias = this.state.frecuenciasBase.filter(f => (f.meses <= formData[0].duracion) && (formData[0].duracion % f.meses === 0));
				}
				component.setState({
					formData: formData[0],
					frecuencias: frecuencias
				});
			}

		}).catch(function(error) {
			
		}).finally(() => {
			this.setState({ loading: false });
		});
	
	}
 
	handleInputFormChange(name, value) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		let frecuencias = this.state.frecuencias;
		if(value && name === "duracion"){
			frecuencias = this.state.frecuenciasBase.filter(f => (f.meses <= value.value) && (value.value % f.meses === 0));
			formDataCopy['frecuencia'] = '';
		}
		formDataCopy[name] = value;
		this.setState({
			formData: formDataCopy,
			frecuencias: frecuencias
		});
  	}

	  handleDatePickerFormChange(name, event) {
        let date = event ? event.format(): null;
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = date;
        this.setState({
            formData: formDataCopy
        });
    }

	handleDatePickerFormRawChange(name, date) {
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[name] = date === '' ? null : date;
        this.setState({
            formData: formDataCopy
        });
    }

	handleCrearConfiguracionPeriodos() {
		
		this.ajaxHandler.fetch('/periodo-configs' + (this.props.action === 'ADD' ? '' : '/' + this.state.formData.id), {
			method: this.props.action === 'ADD' ? 'POST' : 'PUT',
			body: JSON.stringify({
				...this.state.formData
			}),
		}).then(response => {
			if(response.status !== 400) {
				this.exit();
			} else {
				response.json()
					.then(data => {
						this.setState({
							errors: data.detalle
						});
					});
			}
			window.scrollTo(0,0);
		}).catch((error) => {
			this.ajaxHandler.handleError(error);
		}).finally(() => {
			this.setState({ loading: false });
		});

	}

	handleSubmit(event) {
		let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
		formDataCopy.frecuencia = formDataCopy.frecuencia.value;
		formDataCopy.duracion = formDataCopy.duracion.value;
        this.setState({
            formData: formDataCopy,
            loading: true
        }, () => {
            let component = this;

			const queryParams = new URLSearchParams(formDataCopy).toString();
			this.ajaxHandler.fetch(`/periodo-configs/verificar-existencia/${formDataCopy.fecha_inicio}?${queryParams}`, {
				method: 'GET',
			}).then(response => {
				if(response.status === 200) {
					response.json()
						.then(data => {
							if(data.length > 0){
								let html = `<div style="display:flex; width: 100%;justify-content:center">
												<div style="display: flex;width: 90%;padding-bottom: 15px;">
													${this.props.intl.formatMessage({ id: "configPeriodosPresupuestariosAbm.text",
														defaultMessage:"Se detectaron tickets en estado Aprobado o superior dentro del período seleccionado, esto puede afectar la gestión del período. ¿Desea continuar?"})}
												</div>
											</div>
											<div style="display: flex;flex-direction: column;width: 100%;justify-content:center;align-items: center;">
												<div style="display: flex;flex-direction: column;width: 90%;overflow:auto;">
												${
													data.map((tickets) => {
														return `<div style="display: flex;">
																	<b style="white-space: nowrap;"><a href="/tickets/${tickets.id}" target="_blank">Ticket ${tickets.id} -</a></b>
																	<b style="white-space: nowrap;padding-left:4px;text-transform:uppercase !important;">${tickets.ticket_tipo} -</b>
																</div>`
													}
												).join("")}
												</div>
											</div>`
							swal({
								title: this.props.intl.formatMessage({ id: "configPeriodosPresupuestariosAbm.title.validaciones", defaultMessage:"Atención"}),
								html: html,
								icon: "info",
								customClass: 'swal-wide',
								allowOutsideClick: false,
								allowEscapeKey: false,
								showCancelButton: true,
								cancelButtonText: `<i style="margin-right:5px" class="fa fa-times-circle"></i>${this.props.intl.formatMessage({ id: "cancelar", defaultMessage:" Cancelar"})}`,
								confirmButtonText:`<i style="margin-right:5px" class="fa fa-check-circle"></i>${this.props.intl.formatMessage({ id: "continuar", defaultMessage:" Continuar"})}`,
								cancelButtonColor: '#FF3145',
								confirmButtonColor: '#0ABFBC',
								focusConfirm: false
								}).then(res => {
									if (res.value) {
										this.handleCrearConfiguracionPeriodos();
									} else {
										this.setState((prevState) => ({
											formData: {
												...prevState.formData,
												duracion: '',
												frecuencia: ''
											}
										}));
										this.setState({ loading: false });
								}
							});
						} else {
								this.handleCrearConfiguracionPeriodos();
						}
					});
				}
			}).catch((error) => {
				this.ajaxHandler.handleError(error);
			});
        }); 

        event.preventDefault();

	}


	handleCancel(event) {
		this.exit();
	}

	exit() {
		this.setState({
			redirectTo: '/configPeriodosPresupuestarios'
		});
	}

	render() {
		let formData = this.state.formData;
		let state = this.state;
		this.formValidation.validate();
		let validationState = this.formValidation.state;
		return (
			<React.Fragment>
				{this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
				{this.state.loading && <Loading />}				
				<div className="row">
					<div className="col-md-12">
						<div className="alert alert-danger" role="alert" hidden={this.state.errors.length===0}>
							{this.state.errors.map((e, i) => <li key={i}><FormattedMessage {...(backendStrings[e] ? backendStrings[e] : backendStrings['errors.default'])}/></li>)}
						</div>
						<form className="form form-horizontal" ref="form" onSubmit={this.handleSubmit}>
							<div className="form-body">
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">      
											<h4 className="form-section">
												<i className="icon-home"></i><FormattedMessage id="tareasAbm.render.general_data.header_datos_generales" defaultMessage=" Datos Generales "/><div className="float-right" style={{fontSize:'14px'}}>* <FormattedMessage id="tareasAbm.render.general_data.campos_requeridos" defaultMessage="campos requeridos"/></div>
											</h4>
											<div className="row">
												{/* Nombre del ciclo */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="nombre">
															<FormattedMessage id="nombre" defaultMessage="Nombre del ciclo"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.nombre}</div>
															) : (
																<div>
																	<input type="text" className="form-control" id="nombre" name="nombre" placeholder={this.props.intl.formatMessage({ id: 'nombre', defaultMessage: 'nombre' })} value={formData.nombre} onChange={(e) => this.handleInputFormChange('nombre', e.target.value)} /> 
																	<div className="help-block text-danger field-message" hidden={validationState.formData.nombre.pristine || validationState.formData.nombre.valid}>{validationState.formData.nombre.message}</div>
																</div>
															)}															
														</div>
													</div>
												</div>
											</div>
											<div className="row">
												{/* Duración del ciclo */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="duracion">
															<FormattedMessage id="duracion" defaultMessage="Duración del ciclo"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">
																	{formData.duracion ? formData.duracion.label : 'N/A'}
																</div>
															) : (
																<div>
																	<Select
																		id="duracion"
																		name="duracion"
																		placeholder={!state.estadosLoading ? this.props.intl.formatMessage({ id: 'ConfigPeriodosPresupuestariosAbm.placeholder_duracion.Seleccionar', defaultMessage: 'Seleccionar' }) : ''}
																		options={this.state.duraciones}
																		valueKey='value'
																		labelKey='label'
																		disabled={this.state.props.action === 'VIEW'}
																		clearable={false}
																		onChange={(e) => this.handleInputFormChange('duracion', e)}
																		value={formData.duracion}
																	/>
																</div>
															)}															
														</div>
													</div>
												</div>
											</div>
											{formData.duracion ?
												<div className="row">
													{/* Frecuencia */}
													<div className="col-md-6">
														<div className="form-group row">
															<label className="col-md-3 label-control col-form-label" htmlFor="frecuencia">
																<FormattedMessage id="frecuencia" defaultMessage="Frecuencia"/>*:
															</label>
															<div className="col-md-9">
																{this.props.action === 'VIEW' ? (
																	<div className="form-control-static col-form-label form-value">
																		{formData.frecuencia ? formData.frecuencia.label : 'N/A'}
																	</div>
																) : (
																	<div>
																		<Select
																			id="frecuencia"
																			name="frecuencia"
																			placeholder={!state.estadosLoading ? this.props.intl.formatMessage({ id: 'ConfigPeriodosPresupuestariosAbm.placeholder_frecuencia.Seleccionar', defaultMessage: 'Seleccionar' }) : ''}
																			options={this.state.frecuencias}
																			valueKey='value'
																			labelKey='label'
																			disabled={this.state.props.action === 'VIEW'}
																			clearable={false}
																			onChange={(e) => this.handleInputFormChange('frecuencia', e)}
																			value={formData.frecuencia}
																		/>
																	</div>
																)}															
															</div>
														</div>
													</div>
												</div>
											: null}
											<div className="row">
												{/* Fecha Inicio */}
												<div className="col-md-6">
													<div className="form-group row">
														<label className="col-md-3 label-control col-form-label" htmlFor="fecha_inicio">
															<FormattedMessage id="fecha_inicio" defaultMessage="Fecha de inicio del primer período"/>*:
														</label>
														<div className="col-md-9">
															{this.props.action === 'VIEW' ? (
																<div className="form-control-static col-form-label form-value">{formData.fecha_inicio}</div>
															) : (
																<div>
																<DatePicker
																  id="fecha_inicio"
																  name="fecha_inicio"
																  className="form-control date-picker-placeholder"
																  placeholderText={this.props.intl.formatMessage({ id: 'configPeriodosPresupuestariosAbm.render.general_data.placeholder_fecha_inicio', defaultMessage: 'DD/MM/AAAA' })}
																  selected={formData.fecha_inicio === null || formData.fecha_inicio === '0000-00-00' ? null : moment(formData.fecha_inicio) }
																  onChange={(event) => this.handleDatePickerFormChange("fecha_inicio", event)}
																  onChangeRaw={(event) => this.handleDatePickerFormRawChange("fecha_inicio", event.target.value)}
																  openToDate={moment()}
																  dateFormat="DD/MM/YYYY"
																  showMonthDropdown
																  showYearDropdown
																  dropdownMode="select"
																/>
																<div className="help-block text-danger field-message" hidden={validationState.formData.fecha_inicio.pristine || validationState.formData.fecha_inicio.valid}>{validationState.formData.fecha_inicio.message}</div>														
															  </div>
															)}															
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="card pull-up">
									<div className="card-content">
										<div className="card-body">     
											<div className="text-cd text-right">
												{this.props.action !== 'VIEW' && (
													<button type="submit" className="btn btn-primary mr-1" disabled={!validationState.form.valid}>
														<i className="fa fa-check-circle"></i><FormattedMessage id="tareasAbm.finish_button.guardar" defaultMessage=" Guardar"/>
													</button>
												)}
												<button type="button" className="btn btn-danger" onClick={this.handleCancel.bind(this)}>
													<i className="fa fa-times-circle"></i> {this.props.action === 'VIEW' ? this.props.intl.formatMessage({ id: 'tareasAbm.finish_button.volver', defaultMessage: 'Volver' }) : this.props.intl.formatMessage({ id: 'tareasAbm.finish_button.cancelar', defaultMessage: 'Cancelar' })}
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</form>
					</div>
				</div>
			</React.Fragment>
		);
	}
}

export default injectIntl(ConfigPeriodosPresupuestariosAbm);